import { render, staticRenderFns } from "./accurate-distribute.vue?vue&type=template&id=5b3cd074&scoped=true"
import script from "./accurate-distribute.vue?vue&type=script&lang=js"
export * from "./accurate-distribute.vue?vue&type=script&lang=js"
import style0 from "./accurate-distribute.vue?vue&type=style&index=0&id=5b3cd074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cd074",
  null
  
)

export default component.exports